import { Location } from 'react-router-dom';

const AUTH_PATHS = ['/login', '/cadastro', '/esqueci-senha', '/redefinir-senha'];

export interface AuthRedirectState {
  from?: string;
}

function isSafeReturnPath(path: unknown): path is string {
  if (typeof path !== 'string') return false;
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  return !AUTH_PATHS.some((authPath) => path === authPath || path.startsWith(`${authPath}?`));
}

export function currentPath(location: Pick<Location, 'pathname' | 'search' | 'hash'>) {
  return `${location.pathname}${location.search}${location.hash}`;
}

export function loginState(location: Pick<Location, 'pathname' | 'search' | 'hash'>): AuthRedirectState {
  const path = currentPath(location);
  return isSafeReturnPath(path) ? { from: path } : {};
}

export function returnPathFrom(state: unknown): string {
  const from = (state as AuthRedirectState | null)?.from;
  return isSafeReturnPath(from) ? from : '/';
}

export function forwardState(state: unknown): AuthRedirectState {
  const from = (state as AuthRedirectState | null)?.from;
  return isSafeReturnPath(from) ? { from } : {};
}
